import { render, staticRenderFns } from "./DemoRatingLength.vue?vue&type=template&id=99f93fde&"
import script from "./DemoRatingLength.vue?vue&type=script&lang=js&"
export * from "./DemoRatingLength.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRating } from 'vuetify/lib/components/VRating';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VRating,VSlider})
